import React, { useEffect } from "react";
import { useState } from "react";

import { Card, Col, Row, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IoIosMale, IoIosFemale } from "react-icons/io";
import { GiBodyHeight } from "react-icons/gi";
import { FaWeightScale, FaIdCard } from "react-icons/fa6"
import { IoMail } from "react-icons/io5";
import { MdPrivacyTip } from "react-icons/md";
import { HiDocumentSearch } from "react-icons/hi";

import { PALETTE } from "../../common/ThemeConstants";
import { useAuth } from "../../auth/hook";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import SettingsHeader from "../components/SettingsHeader";
import NavLinkButton from "../../common/components/NavLinkButton";
import UserAvatar from "../../common/components/UserAvatar";
import PremiumTag from "../../common/components/PremiumTag";
import { getAge } from "../../account/utils/functions";

export default function Settings() {
    const auth = useAuth();
    const [user, setUser] = useState(auth.user);

    const warning = auth.user.cf === "";
    const isPremium = auth.userSubscription && auth.userSubscription.id !== -1;

    const age = getAge(user.birthdate);

    const sex = user.sex === "M" ?
        (<span><IoIosMale style={{ marginBottom: 3 }} /> <span>Maschio</span></span>) :
        (<span><IoIosFemale style={{ marginBottom: 3 }} /> <span>Femmina</span></span>);

    useEffect(() => {
        window.scrollTo(0, 0);
        setUser(auth.user);
    }, [auth.user]);

    return (
        <div style={{ paddingBottom: 20 }}>
            <SettingsHeader />
            <ContainerResponsive>
                <div
                    className="align-self-center text-center m-auto px-1"
                    style={{ maxWidth: "400px" }}
                >
                    {/* Row 1: Account Type (Free/Premium) */}
                    <Card className="mb-3 p-3" style={{ borderRadius: "10px", border: "2px solid #f2f2f2", background: isPremium ? PALETTE.GRADIENTLIGHT : PALETTE.WHITE }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0" style={{ color: PALETTE.SECONDARYCOLOR }}>
                                    Account {isPremium ? "Premium" : "Base"}
                                </h5>
                            </div>
                            {!isPremium ? (
                                <NavLinkButton
                                    to="/subscriptions"
                                    text="Passa a Premium"
                                    backgroundColor={PALETTE.LINEARGRADIENT}
                                    backgroundColorHover={PALETTE.SECONDARYCOLORHOVER}
                                    color={PALETTE.WHITE}
                                    colorHover={PALETTE.WHITE}
                                    borderColor={PALETTE.MAINCOLOR}
                                    borderColorHover={PALETTE.MAINCOLORHOVER}
                                    shadow={true}
                                    px={true}
                                />
                            )
                                :
                                (
                                    <PremiumTag />
                                )
                            }
                        </div>
                    </Card>

                    {/* Row 2: User Avatar with Name, Surname and Birthdate */}
                    <Card className="mb-3 p-3" style={{ borderRadius: "10px", border: "2px solid #f2f2f2" }}>
                        <Row className="align-items-center">
                            <Col xs={4} className="text-center">
                                <UserAvatar
                                    background={PALETTE.GRADIENTLIGHT}
                                    color={PALETTE.SECONDARYCOLOR}
                                    firstname={user.firstname}
                                    lastname={user.lastname}
                                    cover={user.cover || undefined}
                                    size={55}
                                    fontSize={20}
                                />
                            </Col>
                            <Col xs={8}>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group className="mb-2 text-start">
                                            <Form.Text style={{ fontWeight: "bold" }}>{user.firstname} {user.lastname}</Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Group className="text-start">
                                            <Form.Text style={{ marginBottom: 0, color: PALETTE.GRAY }}>{sex}, {age} anni</Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card>

                    {/* Row 3: Physical Characteristics (Height and Weight) */}
                    <p className="text-start mb-1" style={{ color: PALETTE.DARKGRAY, fontSize: 14, fontWeight: "bold" }}>Caratteristiche Fisiche</p>
                    <Card className="mb-3 p-3" style={{ borderRadius: "10px", border: "2px solid #f2f2f2" }}>
                        <Row>
                            <Col className="px-0">
                                <div className="m-auto shadow-sm rounded-md p-2" style={{ width: 140 }}>
                                    <GiBodyHeight />
                                    <p style={{ marginBottom: 0, marginTop: 4, fontSize: 15 }}>
                                        <span
                                            style={{
                                                fontWeight: "bold",
                                                color: PALETTE.DARKGRAY,
                                            }}
                                        >
                                            {user.height}
                                        </span>
                                        <span style={{ fontSize: 14, color: PALETTE.DARKGRAY }}>
                                            {" cm"}
                                        </span>
                                    </p>
                                    <span style={{ fontSize: 12, color: PALETTE.GRAY }}>
                                        Altezza
                                    </span>
                                </div>
                            </Col>
                            <Col className="px-0">
                                <div className="m-auto shadow-sm rounded-md p-2" style={{ width: 140 }}>
                                    <FaWeightScale />
                                    <p style={{ marginBottom: 0, marginTop: 4, fontSize: 15 }}>
                                        <span
                                            style={{
                                                fontWeight: "bold",
                                                color: PALETTE.DARKGRAY,
                                            }}
                                        >
                                            {user.weight}
                                        </span>
                                        <span style={{ fontSize: 14, color: PALETTE.DARKGRAY }}>
                                            {" kg"}
                                        </span>
                                    </p>
                                    <span style={{ fontSize: 12, color: PALETTE.GRAY }}>
                                        Peso
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Card>

                    {/* Row 4: Fiscal Data (Email and Codice Fiscale) */}
                    <h5 className="text-start mb-1" style={{ color: PALETTE.DARKGRAY, fontWeight: "bold", fontSize: 14 }}>Dati Fiscali</h5>
                    <Card className="mb-3 p-3" style={{ borderRadius: "10px", border: "2px solid #f2f2f2" }}>
                        <Form.Group className="mb-2 text-start">
                            <IoMail style={{ marginBottom: 1, marginRight: 7 }} />
                            <Form.Text
                                style={{ borderRadius: "10px" }}
                            >{user.email}</Form.Text>
                        </Form.Group>
                        <hr style={{ marginBottom: 8, marginTop: 0, marginLeft: 10, color: PALETTE.GRAY }} />
                        <Form.Group className="text-start">
                            <FaIdCard style={{ marginBottom: 1, marginRight: 7 }} />
                            <Form.Text
                                style={{ borderRadius: "10px" }}
                            >{user.cf}</Form.Text>
                        </Form.Group>
                    </Card>
                    {/* Row 5: Privacy Policy and Terms of Service */}
                    <p className="text-start mb-1" style={{ color: PALETTE.DARKGRAY, fontWeight: "bold", fontSize: 14 }}>Documenti Legali</p>
                    <Card className="mb-3 p-3" style={{ borderRadius: "10px", border: "2px solid #f2f2f2" }}>
                        <Form.Group className="mb-2 text-start">
                            <MdPrivacyTip style={{ marginBottom: 1, marginRight: 7 }} />
                            <Form.Text
                                style={{ borderRadius: "10px" }}
                            ><Link to="/PrivacyPolicy" style={{ textDecoration: "none", color: PALETTE.BLACK }}>
                                    Privacy Policy
                                </Link></Form.Text>
                        </Form.Group>
                        <Form.Group className="text-start">
                            <HiDocumentSearch style={{ marginBottom: 1, marginRight: 7 }} />
                            <Form.Text
                                style={{ borderRadius: "10px" }}
                            ><Link to="/TermsOfService" style={{ textDecoration: "none", color: PALETTE.BLACK }}>
                                    Termini di Servizio
                                </Link></Form.Text>
                        </Form.Group>


                    </Card>
                </div>

                {/* Row 6: Sign Out Button */}
                <div
                    className="align-self-center text-center m-auto my-4"
                    style={{ maxWidth: "400px" }}
                >
                    <Button
                        style={{ width: "90%", borderRadius: "10px" }}
                        variant="outline-danger"
                        onClick={auth.logOut}
                    >
                        ESCI
                    </Button>
                </div>

                {/* Row 7: Powered by Simone Bartoli */}
                <p
                    className="text-center"
                    style={{ color: PALETTE.TRUEGRAY, fontSize: 10 }}
                >
                    Powered by{" "}
                    <a
                        href="https://simo6.github.io/"
                        style={{ textDecoration: "none", fontWeight: "bold" }}
                    >
                        Simone Bartoli
                    </a>
                </p>
            </ContainerResponsive>
        </div>
    );
}
